import { render } from "./PassingCreateForm.vue?vue&type=template&id=47ea86fe&scoped=true"
import script from "./PassingCreateForm.vue?vue&type=script&lang=js"
export * from "./PassingCreateForm.vue?vue&type=script&lang=js"

import "./PassingCreateForm.vue?vue&type=style&index=0&id=47ea86fe&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ea86fe"]])

export default __exports__